import React, { useCallback } from 'react';
import { Notification, TypographyBody, Anchor, BellIcon } from '@honeycomb/ui-core';
import { SearchFieldEnum, TripType, useCurrentOpenSearchField, useGlobalContext, useSearch } from '@honeycomb/data';
import reactStringReplace from 'react-string-replace';
import { hotelSRPRouting } from '@honeycomb/routing';
export function RoomSoldOut({ showFullSearch }) {
    const { resourceStrings: { ROOMNAVL_FINDOTHERHOTELS, HOTELROOMS_SOLDOUT_TITLE, HOTELROOMS_SOLDOUT_BODY, ROOMNAVL_TRYALTDATES, }, } = useGlobalContext();
    const [searchState] = useSearch([]);
    const isHotelOnly = searchState.tripType === TripType.Hotel;
    const [_, setOpenField] = useCurrentOpenSearchField();
    const searchAlternateDates = useCallback(() => {
        setTimeout(() => {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
            setOpenField(SearchFieldEnum.DATES);
            showFullSearch === null || showFullSearch === void 0 ? void 0 : showFullSearch(true);
        }, 100);
    }, [setOpenField, showFullSearch]);
    const onClick = useCallback(() => {
        hotelSRPRouting(isHotelOnly);
    }, [isHotelOnly]);
    return (React.createElement(Notification, { color: "warning", icon: React.createElement(BellIcon, null) },
        React.createElement(TypographyBody, { weight: "bold", "data-id": "room-sold-out-heading" }, HOTELROOMS_SOLDOUT_TITLE),
        React.createElement("p", null, reactStringReplace(reactStringReplace(HOTELROOMS_SOLDOUT_BODY, '{0}', () => (React.createElement(Anchor, { key: "alternate-search-text", underline: "always", "data-id": "room-sold-out-alternate-search-text", onClick: searchAlternateDates, component: "button" }, ROOMNAVL_TRYALTDATES))), '{1}', () => (React.createElement(Anchor, { key: "other-hotels-text", underline: "always", onClick: onClick, "data-id": "room-sold-out-other-hotels-text", component: "button" }, ROOMNAVL_FINDOTHERHOTELS))))));
}
